import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { VEHICLE_WIZARD_SAMPLE } from "../consts";
import { VehicleWizardSceneProps } from "../types";
import CheckIcon from "./CheckIcon";

/** Korak "Oprema": popis označene opreme, broj stavki i gdje se oprema koristi. */
const EquipmentScene: React.FC<VehicleWizardSceneProps> = ({ vehicleInfo }) => {
  const equipmentCount = vehicleInfo.equipmentCount ?? 12;

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Oprema vozila</div>
          <div className="mt-3 space-y-2.5">
            {VEHICLE_WIZARD_SAMPLE.equipment.map((item) => (
              <div key={item} className="flex items-center gap-2 rounded-md bg-slate-50 px-2 py-2">
                <CheckIcon />
                <span className="text-[0.7rem] font-medium text-slate-700">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-xs font-bold text-slate-800">Označeno</div>
          <div className="mt-1 flex items-end gap-1">
            <span className="text-3xl font-bold leading-none text-slate-800">{equipmentCount}</span>
            <span className="pb-0.5 text-[0.7rem] text-slate-400">stavki opreme</span>
          </div>
          <div className="mt-3 flex flex-wrap gap-1.5">
            {["Udobnost", "Sigurnost", "Multimedija"].map((group) => (
              <span key={group} className="px-2 py-0.5 rounded-full bg-blue-50 text-[0.6rem] font-semibold text-blue-700">
                {group}
              </span>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Oprema ide u oglas"
          subtitle="i u ponudu, bez ponovnog upisa"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M4 12v7a1 1 0 001 1h14a1 1 0 001-1v-7M16 6l-4-4-4 4M12 2v13" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(EquipmentScene);
